import convertPropNames from 'src/infrastructure/caseConverter'
import http, { Response } from 'src/infrastructure/http'
import { formatDateIso } from 'src/utils/formatDate'
import {
  Movement,
  GetStockMovements,
  FulfillmentCenter,
} from './types'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import { GenericApiErrors } from './email-settings/EmailSettingsTypes'

const getAvailableFulfillmentCenters = async () => {
  try {
    const result = await http.get('/v2/fulfillment-center/access')
    return parseGoodResponse<FulfillmentCenter[]>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const getStockMovements = async ({
  fulfillmentCenterId,
  modelId,
  startDate,
  endDate,
  type,
  page,
  pageSize,
  description,
  sourceSystem,
  code,
  user,
}: GetStockMovements) => {
  const result = await http.get('v2/stock/movements', {
    params: {
      fulfillment_center_id: fulfillmentCenterId || undefined,
      model_id: modelId || undefined,
      start_date: formatDateIso(startDate) || undefined,
      end_date: formatDateIso(endDate) || undefined,
      description: description || undefined,
      source_system: sourceSystem || undefined,
      type,
      page,
      page_size: pageSize,
      code: code || undefined,
      user: user || undefined,
    },
  })

  return convertPropNames<Response<Movement[]>>(result.data)
}

export default {
  getAvailableFulfillmentCenters,
  getStockMovements,
}
